import { ObservableFromFetch } from "../ObservableFromFetch"

export function UserActivationObservable(ApplicationUserId: number, link: string) {
  const requestBody: string = JSON.stringify({ ApplicationUserId: ApplicationUserId, InvitationLink: link })

  return ObservableFromFetch<string>("FFOrderUserFileMaintenance/ReActivateUser", requestBody)
}

export function CompanyActivationObservable(ImplementationID: number, AccountId: number, isLocation: boolean = false) {
  const requestBody: string = new URLSearchParams({
    ImplementationID: ImplementationID.toString(),
    AccountId: AccountId.toString(),
    isLocation: isLocation.toString()
  }).toString()

  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/ReActivateClient?" + requestBody)
}

export function PortalActivationObservable(ImplementationID: number) {
  const requestBody: string = new URLSearchParams({
    ImplementationID: ImplementationID.toString()
  }).toString()

  return ObservableFromFetch<string>("FFOrderClinicFileMaintenance/ReActivateClinic?" + requestBody)
}